/**
 * The base field of view over the player's shoulder.
 *
 * The other entry of [baseFovDegrees](../../../core/view/baseFovDegrees.ts), on exactly the terms
 * the first-person knob states. Its own figure rather than a copy, because the two lenses are two
 * instruments: widening the world around the sights says nothing about how much room the body
 * should stand in.
 */

import { setBaseFovDegrees } from '@/core/view/baseFovDegrees';
import { DEFAULT_FOV_DEGREES, MAX_FOV_DEGREES, MIN_FOV_DEGREES } from '@/sim/camera/viewPreference';
import { rangeApply } from '@/ui/settings/controls/rangeSlider';
import { SETTING_FOV_THIRD_HINT, SETTING_FOV_THIRD_LABEL } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const THIRD_PERSON_FOV_DEGREES: SettingDefinition = {
  id: 'thirdPersonFovDegrees',
  section: 'video',
  label: SETTING_FOV_THIRD_LABEL,
  hint: SETTING_FOV_THIRD_HINT,
  control: {
    kind: 'range',
    min: MIN_FOV_DEGREES,
    max: MAX_FOV_DEGREES,
    step: 1,
    format: (value: number): string => String(Math.round(value)),
  },
  defaultValue: DEFAULT_FOV_DEGREES,
  apply: rangeApply((value: number): void => {
    setBaseFovDegrees('thirdPerson', value);
  }),
};
